import classNames from 'classnames/bind';
import { DetailedHTMLProps, forwardRef, HTMLAttributes, Ref } from 'react';
import { ButtonVariant } from './button';
import styles from './button.module.scss';

const classesContext = classNames.bind(styles);

export interface ButtonLinkProps extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  variant?: ButtonVariant;
}

function ButtonLink(
  { children, className, variant = ButtonVariant.SECONDARY, ...restProps }: ButtonLinkProps,
  ref: Ref<HTMLDivElement>
): JSX.Element {
  return (
    <div
      ref={ref}
      className={classesContext(['button', 'button__link', `button__${variant ? variant : 'primary'}`, className])}
      {...restProps}
    >
      {children}
    </div>
  );
}

export default forwardRef(ButtonLink);
